import { PROJECT_TYPES } from "SharedStores/Project/projectStore";
import { FORM_NAMESPACE, FORM_TYPES } from "SharedStores/Form/formStore";
import { USER_TYPES } from "SharedStores/User/userStore";
import { PROGRAM_TYPES } from "SharedStores/Program/programStore";
import { PROJECT_FORM_CONTROLLER_TYPES } from "./projectFormControllerStore";
import { PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";
import { getNamespacedResource } from "SharedStores/util";
import {
    onDependencyUpdate,
    doPvConfigUpdate,
    doEnergyStorageConfigUpdate,
    E_SIGNATURE_OPTION
} from "./ProjectElements/projectElement";
import {
    SUFFIXES as IncentiveSelectorSuffixes,
    NO_INCENTIVE_DESIGN,
    ADMIN_OVERRIDE_DESIGN,
    incentiveSelectorController
} from "./ProjectElements/incentiveSelectorElementController";
import { DATA_FIELD_TYPE } from "Types/dataFieldTypes";
import { IS_DEBUG_BUILD } from "Util/util";
import { KEYS, NAMESPACE } from "./i18n/projectFormStore.i18n";
import { useProjectLockStore } from "Projects/projectLockStore.js";
import { GlobalEventBus } from "Util/emitter";

//mutations. Do not export
const COMMIT_ELEM_VIS = "commitElementVisibility";
const COMMIT_PVELEM_SHOW_STORAGE = "commitPvElementShowStorage";
const COMMIT_PROJECT_ELEMENT_AUX = "commitProjectElementAux";
const COMMIT_VALIDATION_ERRORS = "commitValidationErrors";
const COMMIT_SAVE_STATE = "commitSaveState";

//actions.export only those that are needed
const CLEAR_ELEMENT = "clearElement";
const FILL_ELEM_DEFAULT = "fillElementDefault";
const APPLY_FORM_DEFAULTS = "applyFormDefaults";
const SET_PROJECT_DATA = "setProjectData";
const SET_SAME_AS = "setSameAs";
const SET_PROJECT_PV_CONFIG = "setProjectPvConfig";
const CALC_PV_OUTPUT = "calcPvOutput";
const SET_PROJECT_ENERGY_STORAGE_CONFIG = "setProjectEnergyStorageConfig";
const CALC_ENERGY_STORAGE_OUTPUT = "calcEnergyStorageOutput";
const GET_INCENTIVE_DESIGN_OPTIONS = "getIncentiveDesignOptions";
const CHANGE_INCENTIVE_DESIGN = "changeIncentiveDesign";
const UPDATE_INCENTIVE = "updateIncentive";
const UPLOAD_ATTACHMENT = "uploadAttachment";
const UPLOAD_ATTACHMENT_OVERRIDE_DRAFT = "uploadAttachmentOverrideDraft";
const AFTER_UPLOAD_ATTACHMENT = "afterUploadAttachment";
const REMOVE_ATTACHMENT = "removeAttachment";
const SET_SIGNATURE_CHOICE = "setSignatureChoice";
const GENERATE_SIGNATURE_DOCUMENT = "generateSignatureDocument";
const REQUEST_SIGNATURES = "requestSignatures";
const CANCEL_ALL_SIGNATURES = "cancelAllSignatures";
const CANCEL_INCOMPLETE_SIGNATURES = "cancelIncompleteSignatures";
const RESEND_SIGNATURE_NOTIFICATIONS = "resendSignatureNotifications";
const REQUEST_SIGNATURES_V2 = "requestSignaturesV2";
const RESEND_ESIGNATURE_NOTIFICATIONS_V2 = "resendESignatureNotificationsV2";
const VOID_SIGNATURES_V2 = "voidSignaturesV2";
const FETCH_ENVELOPE_UPDATE = "fetchEnvelopeUpdate";
const CREATE_WET_SIGN_ENVELOPE = "createWetSignEnvelope";
const GENERATE_ENVELOPE_ITEM_DOCUMENT = "generateEnvelopeItemDocument";
const UPLOAD_WET_SIGN_ENVELOPE_ITEM = "uploadWetSignEnvelopeItem";
const REMOVE_WET_SIGN_ENVELOPE_ITEM = "removeWetSignEnvelopeItem";
const COMPLETE_WET_SIGN_ENVELOPE = "completeWetSignEnvelope";
const SAVE_ENVELOPE_UPDATE = "saveEnvelopeUpdate";
const START_OVER_ENVELOPE = "startOverEnvelope";
const RETRIEVE_SENSITIVE_DATA = "retrieveSensitiveData";
const CALL_WEB_ADAPTER = "callCustomization";
const CONFIRM_DISCARD_UNSAVED_DATA = "confirmDiscardUnsavedData";

//getters
const PROJECT_ELEM_FROM_ID = "projectElementFromId";
const PROJECT_ELEM_FROM_FIELD_ID = "projectElementFromDataFieldId";
const VISIBLE_E_SIGNATURE_ELEMENT_BAGS = "visibleESignatureElementBags";
const IS_ADMIN = "isAdmin";
const IS_VIEW = "isView";
const DO_BATCH_DRAW_ELEMENTS = "doBatchDrawElements";

const PROJECT_FORM_NAMESPACE = "projectForm";
const CLASSIC_ESIGNATURE_DOCUMENT_STATUSES = "classicESignatureDocumentStatuses";
const GET_USER_LOGIN_ID_TO_USER_INFO = "getUserLoginIdToUserInfo";

//exported vuex store types
const PROJECT_FORM_TYPES = {
    actions: {
        [SET_PROJECT_DATA]: getNamespacedResource(PROJECT_FORM_NAMESPACE, SET_PROJECT_DATA),
        [FILL_ELEM_DEFAULT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, FILL_ELEM_DEFAULT),
        [APPLY_FORM_DEFAULTS]: getNamespacedResource(PROJECT_FORM_NAMESPACE, APPLY_FORM_DEFAULTS),
        [CLEAR_ELEMENT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CLEAR_ELEMENT),
        [SET_SAME_AS]: getNamespacedResource(PROJECT_FORM_NAMESPACE, SET_SAME_AS),
        [SET_PROJECT_PV_CONFIG]: getNamespacedResource(PROJECT_FORM_NAMESPACE, SET_PROJECT_PV_CONFIG),
        [CALC_PV_OUTPUT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CALC_PV_OUTPUT),
        [SET_PROJECT_ENERGY_STORAGE_CONFIG]: getNamespacedResource(
            PROJECT_FORM_NAMESPACE,
            SET_PROJECT_ENERGY_STORAGE_CONFIG
        ),
        [CALC_ENERGY_STORAGE_OUTPUT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CALC_ENERGY_STORAGE_OUTPUT),
        [GET_INCENTIVE_DESIGN_OPTIONS]: getNamespacedResource(PROJECT_FORM_NAMESPACE, GET_INCENTIVE_DESIGN_OPTIONS),
        [CHANGE_INCENTIVE_DESIGN]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CHANGE_INCENTIVE_DESIGN),
        [UPDATE_INCENTIVE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, UPDATE_INCENTIVE),
        [UPLOAD_ATTACHMENT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, UPLOAD_ATTACHMENT),
        [UPLOAD_ATTACHMENT_OVERRIDE_DRAFT]: getNamespacedResource(
            PROJECT_FORM_NAMESPACE,
            UPLOAD_ATTACHMENT_OVERRIDE_DRAFT
        ),
        [AFTER_UPLOAD_ATTACHMENT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, AFTER_UPLOAD_ATTACHMENT),
        [REMOVE_ATTACHMENT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, REMOVE_ATTACHMENT),
        [SET_SIGNATURE_CHOICE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, SET_SIGNATURE_CHOICE),
        [GENERATE_SIGNATURE_DOCUMENT]: getNamespacedResource(PROJECT_FORM_NAMESPACE, GENERATE_SIGNATURE_DOCUMENT),
        [REQUEST_SIGNATURES]: getNamespacedResource(PROJECT_FORM_NAMESPACE, REQUEST_SIGNATURES),
        [CANCEL_ALL_SIGNATURES]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CANCEL_ALL_SIGNATURES),
        [CANCEL_INCOMPLETE_SIGNATURES]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CANCEL_INCOMPLETE_SIGNATURES),
        [RESEND_SIGNATURE_NOTIFICATIONS]: getNamespacedResource(PROJECT_FORM_NAMESPACE, RESEND_SIGNATURE_NOTIFICATIONS),
        [REQUEST_SIGNATURES_V2]: getNamespacedResource(PROJECT_FORM_NAMESPACE, REQUEST_SIGNATURES_V2),
        [RESEND_ESIGNATURE_NOTIFICATIONS_V2]: getNamespacedResource(
            PROJECT_FORM_NAMESPACE,
            RESEND_ESIGNATURE_NOTIFICATIONS_V2
        ),
        [VOID_SIGNATURES_V2]: getNamespacedResource(PROJECT_FORM_NAMESPACE, VOID_SIGNATURES_V2),
        [FETCH_ENVELOPE_UPDATE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, FETCH_ENVELOPE_UPDATE),
        [CREATE_WET_SIGN_ENVELOPE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CREATE_WET_SIGN_ENVELOPE),
        [GENERATE_ENVELOPE_ITEM_DOCUMENT]: getNamespacedResource(
            PROJECT_FORM_NAMESPACE,
            GENERATE_ENVELOPE_ITEM_DOCUMENT
        ),
        [UPLOAD_WET_SIGN_ENVELOPE_ITEM]: getNamespacedResource(PROJECT_FORM_NAMESPACE, UPLOAD_WET_SIGN_ENVELOPE_ITEM),
        [REMOVE_WET_SIGN_ENVELOPE_ITEM]: getNamespacedResource(PROJECT_FORM_NAMESPACE, REMOVE_WET_SIGN_ENVELOPE_ITEM),
        [COMPLETE_WET_SIGN_ENVELOPE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, COMPLETE_WET_SIGN_ENVELOPE),
        [SAVE_ENVELOPE_UPDATE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, SAVE_ENVELOPE_UPDATE),
        [START_OVER_ENVELOPE]: getNamespacedResource(PROJECT_FORM_NAMESPACE, START_OVER_ENVELOPE),
        [RETRIEVE_SENSITIVE_DATA]: getNamespacedResource(PROJECT_FORM_NAMESPACE, RETRIEVE_SENSITIVE_DATA),
        [CALL_WEB_ADAPTER]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CALL_WEB_ADAPTER),
        [CONFIRM_DISCARD_UNSAVED_DATA]: getNamespacedResource(PROJECT_FORM_NAMESPACE, CONFIRM_DISCARD_UNSAVED_DATA)
    },
    getters: {
        [PROJECT_ELEM_FROM_ID]: getNamespacedResource(PROJECT_FORM_NAMESPACE, PROJECT_ELEM_FROM_ID),
        [PROJECT_ELEM_FROM_FIELD_ID]: getNamespacedResource(PROJECT_FORM_NAMESPACE, PROJECT_ELEM_FROM_FIELD_ID),
        [VISIBLE_E_SIGNATURE_ELEMENT_BAGS]: getNamespacedResource(
            PROJECT_FORM_NAMESPACE,
            VISIBLE_E_SIGNATURE_ELEMENT_BAGS
        ),
        [IS_ADMIN]: getNamespacedResource(PROJECT_FORM_NAMESPACE, IS_ADMIN),
        [IS_VIEW]: getNamespacedResource(PROJECT_FORM_NAMESPACE, IS_VIEW),
        [DO_BATCH_DRAW_ELEMENTS]: getNamespacedResource(PROJECT_FORM_NAMESPACE, DO_BATCH_DRAW_ELEMENTS),
        [CLASSIC_ESIGNATURE_DOCUMENT_STATUSES]: getNamespacedResource(
            PROJECT_FORM_NAMESPACE,
            CLASSIC_ESIGNATURE_DOCUMENT_STATUSES
        ),
        [GET_USER_LOGIN_ID_TO_USER_INFO]: getNamespacedResource(PROJECT_FORM_NAMESPACE, GET_USER_LOGIN_ID_TO_USER_INFO)
    }
};

// these mutations and actions are not exported in the normal types object
// because they should only be used in very specific places, and not elsewhere
export const AUX_MUTATION = getNamespacedResource(PROJECT_FORM_NAMESPACE, COMMIT_PROJECT_ELEMENT_AUX);
export const VALIDATION_ERRORS_MUTATION = getNamespacedResource(PROJECT_FORM_NAMESPACE, COMMIT_VALIDATION_ERRORS);
export const ELEM_VIS_MUTATION = getNamespacedResource(PROJECT_FORM_NAMESPACE, COMMIT_ELEM_VIS);
export const PVELEM_SHOW_STORAGE_MUTATION = getNamespacedResource(PROJECT_FORM_NAMESPACE, COMMIT_PVELEM_SHOW_STORAGE);
export const SAVE_STATE_MUTATION = getNamespacedResource(PROJECT_FORM_NAMESPACE, COMMIT_SAVE_STATE);

export { PROJECT_FORM_NAMESPACE, PROJECT_FORM_TYPES };

export const PROJECT_FORM_MODE = {
    Edit: 0,
    View: 1,
    Admin: 2,
    Preview: 3,
    Prefill: 4,
    PrefillAdmin: 5,
    Print: 6,
    AdminReadonly: 7,
    AdminEdit: 8
};

export const ADMIN_FORM_MODE = {
    Edit: PROJECT_FORM_MODE.AdminEdit,
    View: PROJECT_FORM_MODE.AdminReadonly,
    EditSubmitted: PROJECT_FORM_MODE.Admin
};

export const PROJECT_FORM_SAVE_STATE = {
    Initial: 0,
    Saved: 1,
    Saving: 2,
    HasUnsaved: 3
};

function registerDependency(dependencyIndex, elementId, dependencyFieldId) {
    if (!dependencyIndex[dependencyFieldId]) {
        dependencyIndex[dependencyFieldId] = {};
    }
    const fieldDependencies = dependencyIndex[dependencyFieldId];
    fieldDependencies[elementId] = true;
}

export function createProjectFormModule($app, baseController, state) {
    const projectLockStore = useProjectLockStore();
    state.validationErrors = null;
    state.saveState = state.InitialSaveState;
    state.hasResentESignatures = false;

    function getI18nStr(key) {
        return $app.res({
            namespace: NAMESPACE,
            key: key
        });
    }

    return {
        namespaced: true,
        state: state,
        getters: {
            [PROJECT_ELEM_FROM_ID](state, getters) {
                return function (elementId) {
                    let projectElement = state.ProjectElements[elementId];
                    if (projectElement) {
                        const hasValidationError = getters.elementErrorsMap[elementId] ? true : false;
                        projectElement = {
                            ...projectElement,
                            hasValidationError
                        };
                    }

                    return projectElement;
                };
            },
            [PROJECT_ELEM_FROM_FIELD_ID](state, getters) {
                return function (dataFieldId) {
                    const elementId = getters.fieldToElementIndex[dataFieldId];
                    return getters[PROJECT_ELEM_FROM_ID](elementId);
                };
            },
            [VISIBLE_E_SIGNATURE_ELEMENT_BAGS](state, getters, rootState, rootGetters) {
                const eSigElementBags = [];
                const orderedElements = rootGetters[FORM_TYPES.getters.orderedFormElements];
                orderedElements.forEach((element) => {
                    const projectElement = getters[PROJECT_ELEM_FROM_ID](element.PublicId);
                    if (
                        projectElement.IsVisible &&
                        element.ClassName == "AttachmentElement" &&
                        projectElement.AuxiliaryModel &&
                        projectElement.AuxiliaryModel.SignatureChoice === E_SIGNATURE_OPTION.Required
                    ) {
                        eSigElementBags.push({
                            projectElement,
                            element
                        });
                    }
                });
                return eSigElementBags;
            },
            fieldToElementIndex(state, getters, rootState) {
                const fieldToElem = {};
                for (const publicId in rootState[FORM_NAMESPACE].FormElements) {
                    if (rootState[FORM_NAMESPACE].FormElements.hasOwnProperty(publicId)) {
                        const element = rootState[FORM_NAMESPACE].FormElements[publicId];
                        if (element.DataFieldId) {
                            fieldToElem[element.DataFieldId] = element.PublicId;
                        }
                        if (element.DataFieldGroupId && element.GroupDataFields) {
                            for (const suffix in element.GroupDataFields) {
                                if (element.GroupDataFields.hasOwnProperty(suffix)) {
                                    const dataFieldId = element.GroupDataFields[suffix];
                                    fieldToElem[dataFieldId] = element.PublicId;
                                }
                            }
                        }
                    }
                }
                return fieldToElem;
            },
            fieldToElementDependencyIndex(state) {
                const fieldToElemDependency = {};
                for (const publicId in state.ProjectElements) {
                    if (state.ProjectElements.hasOwnProperty(publicId)) {
                        const projectElement = state.ProjectElements[publicId];
                        if (projectElement.FieldDependencies && projectElement.FieldDependencies.length > 0) {
                            projectElement.FieldDependencies.forEach((dataFieldId) => {
                                registerDependency(fieldToElemDependency, projectElement.FormElementId, dataFieldId);
                            });
                        }
                    }
                }
                return fieldToElemDependency;
            },
            elementErrorsMap(state) {
                const elementErrorsMap = {};
                if (state.validationErrors && state.validationErrors.length > 0) {
                    state.validationErrors.forEach((ve) => {
                        if (ve.FormElementPublicId) {
                            elementErrorsMap[ve.FormElementPublicId] = true;
                        }
                    });
                }
                return elementErrorsMap;
            },
            [IS_ADMIN](state) {
                return (
                    state.ProjectFormMode === PROJECT_FORM_MODE.Admin ||
                    state.ProjectFormMode === PROJECT_FORM_MODE.AdminReadonly
                );
            },
            [IS_VIEW](state) {
                const mode = state.ProjectFormMode;
                return (
                    mode === PROJECT_FORM_MODE.View ||
                    mode === PROJECT_FORM_MODE.Print ||
                    mode === PROJECT_FORM_MODE.AdminReadonly
                );
            },
            [DO_BATCH_DRAW_ELEMENTS](state, getters) {
                return getters[IS_ADMIN];
            },
            [CLASSIC_ESIGNATURE_DOCUMENT_STATUSES](state) {
                return state.ClientDocumentStatuses;
            },
            [GET_USER_LOGIN_ID_TO_USER_INFO](state) {
                return function (loginId) {
                    const loginIdStr = String(loginId);
                    return state.UserLoginIdToUserInfo[loginIdStr];
                };
            },
            // Retrieves the auxiliary state related to legacy eSignatures for a particular
            // attachment element
            getAttachmentElementESignatureStatus(state, getters, rootState, rootGetters) {
                return function (elementId) {
                    const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                    if (element.ClassName !== "AttachmentElement") {
                        throw new Error("Cannot set signature choice for non attachment element");
                    }
                    return { ...state.ProjectElements[elementId].AuxiliaryModel };
                };
            }
        },
        mutations: {
            [COMMIT_ELEM_VIS](state, { elementId, isVisible }) {
                const boolValue = Boolean(isVisible);
                state.ProjectElements[elementId].IsVisible = boolValue;
            },
            [COMMIT_PVELEM_SHOW_STORAGE](state, { elementId, shouldShowStorageEquipment }) {
                const boolValue = Boolean(shouldShowStorageEquipment);
                state.ProjectElements[elementId].AuxiliaryModel.pvShowStorageEquipment = boolValue;
            },
            commitProjectElementFieldDependencies(state, { elementId, fieldDependencies }) {
                state.ProjectElements[elementId].FieldDependencies = fieldDependencies;
            },
            [COMMIT_PROJECT_ELEMENT_AUX](state, { elementId, auxState }) {
                state.ProjectElements[elementId].auxState = auxState || null;
            },
            commitSignatureStatus(state, { elementId, signatureStatus }) {
                state.ProjectElements[elementId].AuxiliaryModel = signatureStatus;
            },
            commitSignatureRequestStatus(state, { elementId, signatureRequestStatus }) {
                state.ProjectElements[elementId].AuxiliaryModel = signatureRequestStatus;
            },
            commitClassicESignatureDocumentStatuses(state, { classicESignatureDocumentStatus }) {
                state.ClientDocumentStatuses = classicESignatureDocumentStatus;
            },
            [COMMIT_VALIDATION_ERRORS](state, validationErrors) {
                state.validationErrors = validationErrors;
            },
            clearValidationErrorForElementId(state, elementId) {
                if (state.validationErrors && state.validationErrors.length > 0) {
                    state.validationErrors = state.validationErrors.filter(
                        (ve) => ve.FormElementPublicId !== elementId
                    );
                }
            },
            [COMMIT_SAVE_STATE](state, saveState) {
                state.saveState = saveState;
            },
            commitDefaultsApplied(state) {
                state.HasAnyDefaultToApply = false;
            },
            commitHasResentNotifications(state, value) {
                state.hasResentESignatures = value;
            }
        },
        actions: {
            async [UPLOAD_ATTACHMENT]({ dispatch }, { file, formElementId, attachmentDefinitionId, captureXhr }) {
                const uploadResult = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.uploadAttachment,
                    { file, formElementId, attachmentDefinitionId, captureXhr },
                    { root: true }
                );
                return dispatch(AFTER_UPLOAD_ATTACHMENT, { uploadResult, formElementId, attachmentDefinitionId });
            },
            async [UPLOAD_ATTACHMENT_OVERRIDE_DRAFT](
                { dispatch },
                { file, formElementId, attachmentDefinitionId, useDraftStorage, captureXhr }
            ) {
                const uploadResult = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.uploadAttachmentInternal,
                    { file, formElementId, attachmentDefinitionId, useDraftStorage, captureXhr },
                    { root: true }
                );
                return dispatch(AFTER_UPLOAD_ATTACHMENT, { uploadResult, formElementId, attachmentDefinitionId });
            },
            [AFTER_UPLOAD_ATTACHMENT](
                { getters, dispatch, commit },
                { uploadResult, formElementId, attachmentDefinitionId }
            ) {
                // if there is an error associated with with the attachment element, clear it.
                if (formElementId) {
                    const currentProjectElement = getters[PROJECT_ELEM_FROM_ID](formElementId);
                    if (currentProjectElement && currentProjectElement.hasValidationError) {
                        commit("clearValidationErrorForElementId", formElementId);
                    }
                }

                const attachment = uploadResult.Attachment;
                commit(
                    PROJECT_TYPES.mutations.commitAttachment,
                    {
                        attachmentId: attachmentDefinitionId,
                        value: attachment
                    },
                    { root: true }
                );

                if (uploadResult.DataExtractorOutputMap) {
                    for (const dataFieldId in uploadResult.DataExtractorOutputMap) {
                        if (uploadResult.DataExtractorOutputMap.hasOwnProperty(dataFieldId)) {
                            const extractorOutput = uploadResult.DataExtractorOutputMap[dataFieldId];
                            const value = extractorOutput.Data ?? extractorOutput.MultiInstanceData;
                            dispatch(SET_PROJECT_DATA, { dataFieldId, value });
                        }
                    }
                    GlobalEventBus.emit("update_custom_lists");
                }

                return {
                    attachment,
                    extractorFailureFields: uploadResult.DataExtractorFailedFields,
                    validationResponse: uploadResult.ValidationResponse
                };
            },
            async [REMOVE_ATTACHMENT]({ dispatch, commit }, { attachmentDefinitionId }) {
                //wait for the removal to be succesful before removing the attachment from the store
                await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.removeAttachment,
                    { attachmentDefinitionId },
                    { root: true }
                );
                commit(
                    PROJECT_TYPES.mutations.commitAttachment,
                    {
                        attachmentId: attachmentDefinitionId,
                        value: null
                    },
                    { root: true }
                );
            },
            [SET_SIGNATURE_CHOICE]({ commit, getters, dispatch }, { elementId, signatureChoice }) {
                const signatureStatus = getters.getAttachmentElementESignatureStatus(elementId);
                signatureStatus.SignatureChoice = signatureChoice;
                if (signatureStatus.SignatureChoice !== E_SIGNATURE_OPTION.Required) {
                    signatureStatus.IsReady = false;
                }
                commit("commitSignatureStatus", { elementId, signatureStatus });
                return dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.setSignatureChoice,
                    { elementId, signatureChoice },
                    { root: true }
                );
            },
            async [GENERATE_SIGNATURE_DOCUMENT]({ commit, getters, dispatch }, { elementId }) {
                // Mark this document no longer ready. Otherwise it's possible to request signatures based
                // on an old document while generating this one is still in progress.
                const signatureStatus = getters.getAttachmentElementESignatureStatus(elementId);
                signatureStatus.IsReady = false;
                signatureStatus.DocumentId = null;
                commit("commitSignatureStatus", { elementId, signatureStatus });

                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData, null, { root: true });
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.generateSignatureDocument,
                    { elementId },
                    { root: true }
                );
                commit("commitSignatureStatus", { elementId, signatureStatus: result });
            },
            async [REQUEST_SIGNATURES](context) {
                await context.dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData, null, { root: true });

                const result = await context.dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.requestSignatures, null, {
                    root: true
                });

                commitUpdateClassicESignatureDocumentStatuses(context, {
                    classicESignatureDocumentStatus: result.Data
                });

                commitSignatureAndRequestStatus(context, {
                    signatureRequested: true,
                    signatureRequestStatus: result.Data,
                    allSignatures: true
                });
            },
            async [CANCEL_ALL_SIGNATURES](context, cancelExplanationData) {
                await context.dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.cancelAllSignatures,
                    cancelExplanationData,
                    { root: true }
                );

                commitUpdateClassicESignatureDocumentStatuses(context, { classicESignatureDocumentStatus: [] });

                commitSignatureAndRequestStatus(context, {
                    signatureRequested: false,
                    signatureRequestStatus: null,
                    allSignatures: true
                });
            },
            async [CANCEL_INCOMPLETE_SIGNATURES](context, cancelExplanationData) {
                await context.dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.cancelIncompleteSignatures,
                    cancelExplanationData,
                    { root: true }
                );
                commitSignatureAndRequestStatus(context, {
                    signatureRequested: false,
                    signatureRequestStatus: null,
                    allSignatures: false
                });
            },
            async [RESEND_SIGNATURE_NOTIFICATIONS](context) {
                const result = await context.dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.resendSignatureNotifications,
                    null,
                    { root: true }
                );
                commitSignatureAndRequestStatus(context, {
                    signatureRequested: true,
                    signatureRequestStatus: result.Data.DocumentStatuses,
                    allSignatures: true
                });
                context.commit("commitHasResentNotifications", true);
            },
            async [REQUEST_SIGNATURES_V2]({ commit, dispatch }, { envelopeDefinitionId }) {
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData, null, { root: true });

                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.requestSignaturesV2,
                    { envelopeDefinitionId },
                    { root: true }
                );

                const envelope = result.Data.Envelope;
                commit(
                    PROJECT_TYPES.mutations.commitEnvelope,
                    {
                        envelopeDefinitionId: envelopeDefinitionId,
                        value: envelope
                    },
                    { root: true }
                );
                return result;
            },
            async [RESEND_ESIGNATURE_NOTIFICATIONS_V2]({ commit, dispatch }, { envelopeId }) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.resendESignatureNotificationsV2,
                    {
                        envelopeId: envelopeId
                    },
                    { root: true }
                );

                const envelope = result.Data.Envelope;
                commit(
                    PROJECT_TYPES.mutations.commitEnvelope,
                    {
                        envelopeDefinitionId: envelope.Definition.PublicId,
                        value: envelope
                    },
                    { root: true }
                );
                return result;
            },
            async [VOID_SIGNATURES_V2]({ dispatch }, { envelopeId, explanationType, explanationDetail }) {
                await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.voidSignaturesV2,
                    {
                        envelopeId: envelopeId,
                        explanationType: explanationType,
                        explanationDetail: explanationDetail
                    },
                    { root: true }
                );

                await dispatch(PROJECT_TYPES.actions.removeEnvelope, { envelopeId: envelopeId }, { root: true });
            },
            async [FETCH_ENVELOPE_UPDATE]({ dispatch }, { envelopeId }) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.fetchEnvelopeUpdate,
                    { envelopeId },
                    { root: true }
                );

                const envelope = result.Data.Envelope;
                await dispatch(PROJECT_FORM_TYPES.actions.saveEnvelopeUpdate, { envelope }, { root: true });

                return result;
            },
            async [CREATE_WET_SIGN_ENVELOPE]({ commit, dispatch }, { envelopeDefinitionId }) {
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData, null, { root: true });
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.createWetSignEnvelope,
                    { envelopeDefinitionId },
                    { root: true }
                );

                const envelope = result.Data.Envelope;
                commit(
                    PROJECT_TYPES.mutations.commitEnvelope,
                    {
                        envelopeDefinitionId: envelopeDefinitionId,
                        value: envelope
                    },
                    { root: true }
                );
                return result;
            },
            async [GENERATE_ENVELOPE_ITEM_DOCUMENT]({ dispatch }, { envelopeItemDefinitionId }) {
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData, null, { root: true });
                return await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.generateEnvelopeItemDocument,
                    { envelopeItemDefinitionId },
                    { root: true }
                );
            },
            async [UPLOAD_WET_SIGN_ENVELOPE_ITEM](
                { commit, dispatch },
                { file, envelopeId, envelopeItemId, captureXhr }
            ) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.uploadWetSignEnvelopeItem,
                    { file, envelopeId, envelopeItemId, captureXhr },
                    { root: true }
                );

                const envelope = result.Envelope;
                const envelopeDefinitionId = envelope.Definition.PublicId;
                commit(
                    PROJECT_TYPES.mutations.commitEnvelope,
                    {
                        envelopeDefinitionId: envelopeDefinitionId,
                        value: envelope
                    },
                    { root: true }
                );

                return envelope;
            },
            async [REMOVE_WET_SIGN_ENVELOPE_ITEM]({ commit, dispatch }, { envelopeId, envelopeItemId }) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.removeWetSignEnvelopeItem,
                    { envelopeId, envelopeItemId },
                    { root: true }
                );
                const envelope = result.Envelope;
                const envelopeDefinitionId = envelope.Definition.PublicId;
                commit(
                    PROJECT_TYPES.mutations.commitEnvelope,
                    {
                        envelopeDefinitionId: envelopeDefinitionId,
                        value: envelope
                    },
                    { root: true }
                );

                return envelope;
            },
            [SAVE_ENVELOPE_UPDATE]({ commit }, { envelope }) {
                function commitAttachment(attachment) {
                    if (attachment) {
                        commit(
                            PROJECT_TYPES.mutations.commitAttachment,
                            {
                                attachmentId: attachment.AttachmentDefinitionId,
                                value: attachment
                            },
                            { root: true }
                        );
                    }
                }

                const envelopeDefinitionId = envelope.Definition.PublicId;

                commit(
                    PROJECT_TYPES.mutations.commitEnvelope,
                    {
                        envelopeDefinitionId: envelopeDefinitionId,
                        value: envelope
                    },
                    { root: true }
                );

                for (const attachment of Object.values(envelope.AttachmentsById)) {
                    commitAttachment(attachment);
                }
            },
            async [COMPLETE_WET_SIGN_ENVELOPE]({ dispatch }, { envelopeId }) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.completeWetSignEnvelope,
                    { envelopeId },
                    { root: true }
                );

                const envelope = result.Envelope;
                await dispatch(PROJECT_FORM_TYPES.actions.saveEnvelopeUpdate, { envelope }, { root: true });

                return envelope;
            },
            async [START_OVER_ENVELOPE]({ dispatch }, { envelopeId }) {
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.startOverEnvelope, { envelopeId }, { root: true });
                await dispatch(PROJECT_TYPES.actions.removeEnvelope, { envelopeId: envelopeId }, { root: true });
            },
            async [RETRIEVE_SENSITIVE_DATA]({ dispatch }, { elementId }) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.retrieveSensitiveData,
                    { elementId },
                    { root: true }
                );
                return result;
            },
            async [CALL_WEB_ADAPTER]({ dispatch }, { elementId, customizationId, configurationId }) {
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.callCustomization,
                    { elementId, customizationId, configurationId },
                    { root: true }
                );
                if (result.Data.OutputValues) {
                    for (const dataFieldId in result.Data.OutputValues) {
                        if (result.Data.OutputValues.hasOwnProperty(dataFieldId)) {
                            const value = result.Data.OutputValues[dataFieldId];
                            dispatch(SET_PROJECT_DATA, { dataFieldId, value });
                        }
                    }
                }
                return {
                    hasError: Boolean(result.Data.ErrorMessage),
                    error: result.Data.ErrorMessage,
                    Warning: result.Data.Warning
                };
            },
            async [SET_SAME_AS]({ commit, getters, rootGetters, dispatch }, { destElementId, sourceElementId }) {
                const element = rootGetters[FORM_TYPES.getters.elementFromId](destElementId);
                const projectElement = getters[PROJECT_ELEM_FROM_ID](destElementId);

                const sourceElement = rootGetters[FORM_TYPES.getters.elementFromId](sourceElementId);
                const sourceGroupId = (sourceElement && sourceElement.DataFieldGroupId) || null;

                const helper = async function (newFieldDeps) {
                    commit("commitProjectElementFieldDependencies", {
                        elementId: destElementId,
                        fieldDependencies: newFieldDeps
                    });
                    if (newFieldDeps.length <= 0) {
                        await dispatch(CLEAR_ELEMENT, { elementId: destElementId });
                    } else {
                        await onDependencyUpdate({
                            $app,
                            baseController,
                            element,
                            projectElement,
                            dataFieldId: newFieldDeps[0],
                            rootGetters,
                            dispatch
                        });
                    }
                };

                //commit changes first to give impression of working faster.
                //we'll need to recommit changes after to make sure we have the right things
                let newFieldDeps =
                    sourceGroupId != null
                        ? rootGetters[PROGRAM_TYPES.getters.dataFieldGroupDefinitionFromId](sourceGroupId).DataFieldIds
                        : [];
                await helper(newFieldDeps);

                //talk to the webserver to save the new data dependencies
                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.saveConditionalDependencies,
                    { formElementId: destElementId, groupDefinitionId: sourceGroupId },
                    { root: true }
                );
                newFieldDeps = result.Data || [];
                await helper(newFieldDeps);
            },
            [CLEAR_ELEMENT]({ rootGetters, dispatch }, { elementId }) {
                const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                const propVal = element.Properties.readonly || "";
                const isReadonly = propVal.toLowerCase() === "true";
                if (
                    isReadonly ||
                    element.ClassName === "SummationElement" ||
                    element.ClassName === "ProjectTableElement"
                ) {
                    return;
                }
                if (element.DataFieldId) {
                    dispatch(SET_PROJECT_DATA, { dataFieldId: element.DataFieldId, value: "" });
                } else if (element.DataFieldGroupId && element.GroupDataFields) {
                    for (const suffix in element.GroupDataFields) {
                        if (element.GroupDataFields.hasOwnProperty(suffix)) {
                            const dataFieldId = element.GroupDataFields[suffix];
                            const dfd = rootGetters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](dataFieldId);
                            if (dfd.IsMultiInstance) {
                                dispatch(SET_PROJECT_DATA, { dataFieldId, value: [] });
                            } else if (
                                element.ClassName === "IncentiveSelectorElement" &&
                                suffix === IncentiveSelectorSuffixes.inputFields.SelectedIncentiveDesign
                            ) {
                                dispatch(CHANGE_INCENTIVE_DESIGN, {
                                    elementId: element.PublicId,
                                    selectedDesignPublicId: NO_INCENTIVE_DESIGN,
                                    selectedDesignName: NO_INCENTIVE_DESIGN
                                });
                            } else {
                                dispatch(SET_PROJECT_DATA, { dataFieldId, value: "" });
                            }
                        }
                    }
                }
            },
            [FILL_ELEM_DEFAULT]({ rootGetters, dispatch }, { elementId }) {
                const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                const propVal = element.Properties.readonly || "";
                const isReadonly = propVal.toLowerCase() === "true";
                if (isReadonly) {
                    return;
                }
                const fillDefaultForField = function (dataFieldId, elementDefault) {
                    if (dataFieldId) {
                        const dfd = rootGetters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](dataFieldId);
                        let value =
                            rootGetters[USER_TYPES.getters.dataPrefillFromId](dataFieldId) || elementDefault || null;
                        // boolean values cannot be empty if shown. Set to false if no default is found
                        if (dfd.TypeId === DATA_FIELD_TYPE.Boolean) {
                            if (!value) {
                                value = "false";
                            }
                        }
                        // choice defaults must use the list element's id
                        if (dfd.TypeId === DATA_FIELD_TYPE.Choice) {
                            if (value) {
                                const namedItem = rootGetters[PROGRAM_TYPES.getters.listItemByValueAndFieldId](
                                    value,
                                    dataFieldId
                                );
                                if (namedItem) {
                                    value = namedItem.ListItemId;
                                } else {
                                    value = "";
                                }
                            }
                        }
                        if (value) {
                            dispatch(SET_PROJECT_DATA, { dataFieldId, value });
                        }
                    }
                };

                if (element.DataFieldId) {
                    fillDefaultForField(element.DataFieldId, element.Properties.default);
                } else if (element.DataFieldGroupId && element.GroupDataFields) {
                    for (const suffix in element.GroupDataFields) {
                        if (element.GroupDataFields.hasOwnProperty(suffix)) {
                            const dataFieldId = element.GroupDataFields[suffix];
                            fillDefaultForField(dataFieldId, null);
                        }
                    }
                }
            },
            [APPLY_FORM_DEFAULTS]({ state, rootState, getters, commit, dispatch }) {
                if (state.ProjectFormMode !== PROJECT_FORM_MODE.Admin || !state.HasAnyDefaultToApply) {
                    return;
                }

                for (const elementId in rootState[FORM_NAMESPACE].FormElements) {
                    if (rootState[FORM_NAMESPACE].FormElements.hasOwnProperty(elementId)) {
                        const projectElement = getters[PROJECT_ELEM_FROM_ID](elementId);
                        if (projectElement.IsVisible) {
                            dispatch(FILL_ELEM_DEFAULT, { elementId });
                        }
                    }
                }
                commit("commitDefaultsApplied");
            },
            [SET_PROJECT_PV_CONFIG](
                { /*state,*/ getters, rootGetters, commit, dispatch },
                { elementId, pvConfig, systemIsNew }
            ) {
                const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                const projectElement = getters[PROJECT_ELEM_FROM_ID](elementId);

                doPvConfigUpdate(element, projectElement, pvConfig, systemIsNew, commit, dispatch);
            },
            async [CALC_PV_OUTPUT]({ dispatch }, { elementId }) {
                const { promise, resolveHook, rejectHook } = createPromiseAndGetResolveRejectHooks();
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.registerSavePromise, promise, { root: true });

                const queueOptions = { skipQueue: true };
                try {
                    await dispatch(
                        PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData,
                        { queueOptions },
                        { root: true }
                    );
                } catch (ex) {
                    // Common cause of this exception would be if this was triggered on the admin page
                    // and user declined to save form data. In that case, reject the queued promise and
                    // rethrow to stop any additional action. If we don't reject the manually queued promise,
                    // it will remain pending forever and will block any future queued saves
                    rejectHook(ex);
                    throw ex;
                }

                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.calcPvOutput,
                    { formElementId: elementId, queueOptions },
                    { root: true }
                );
                const dataPromises = [];
                if (result.Data.OutputValues) {
                    for (const dataFieldId in result.Data.OutputValues) {
                        if (result.Data.OutputValues.hasOwnProperty(dataFieldId)) {
                            const value = result.Data.OutputValues[dataFieldId];
                            if (value) {
                                dataPromises.push(dispatch(SET_PROJECT_DATA, { dataFieldId, value }));
                            }
                        }
                    }
                }
                // make sure to resolve after we set the data,
                // but before the data promises themseles, since those can cause saves too.
                resolveHook();
                await Promise.all(dataPromises);

                return { hasError: Boolean(result.Data.ErrorMessage), error: result.Data.ErrorMessage };
            },

            [SET_PROJECT_ENERGY_STORAGE_CONFIG](
                { getters, rootGetters, commit, dispatch },
                { elementId, energyStorageConfig }
            ) {
                const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                const projectElement = getters[PROJECT_ELEM_FROM_ID](elementId);

                doEnergyStorageConfigUpdate(element, projectElement, energyStorageConfig, commit, dispatch);
            },

            async [CALC_ENERGY_STORAGE_OUTPUT]({ dispatch }, { elementId }) {
                const { promise, resolveHook, rejectHook } = createPromiseAndGetResolveRejectHooks();
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.registerSavePromise, promise, { root: true });

                const queueOptions = { skipQueue: true };
                try {
                    await dispatch(
                        PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData,
                        { queueOptions },
                        { root: true }
                    );
                } catch (ex) {
                    rejectHook(ex);
                    throw ex;
                }

                const result = await dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.calcEnergyStorageOutput,
                    { formElementId: elementId, queueOptions },
                    { root: true }
                );
                const dataPromises = [];
                if (result.Data.OutputValues) {
                    for (const dataFieldId in result.Data.OutputValues) {
                        if (result.Data.OutputValues.hasOwnProperty(dataFieldId)) {
                            const value = result.Data.OutputValues[dataFieldId];
                            if (value) {
                                dataPromises.push(dispatch(SET_PROJECT_DATA, { dataFieldId, value }));
                            }
                        }
                    }
                }
                // make sure to resolve after we set the data,
                // but before the data promises themseles, since those can cause saves too.
                resolveHook();
                await Promise.all(dataPromises);

                return { hasError: Boolean(result.Data.ErrorMessage), error: result.Data.ErrorMessage };
            },

            [GET_INCENTIVE_DESIGN_OPTIONS]({ dispatch }, { formElementId, incentiveDesignId }) {
                const result = dispatch(
                    PROJECT_FORM_CONTROLLER_TYPES.actions.getIncentiveDesignOptions,
                    {
                        formElementId: formElementId,
                        incentiveDesignId: incentiveDesignId
                    },
                    { root: true }
                );
                return result;
            },
            async [CHANGE_INCENTIVE_DESIGN](
                { getters, rootGetters, commit, dispatch },
                { elementId, selectedDesignPublicId, selectedDesignName }
            ) {
                const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                const projectElement = getters[PROJECT_ELEM_FROM_ID](elementId);
                const dataFieldId =
                    element.GroupDataFields[IncentiveSelectorSuffixes.inputFields.SelectedIncentiveDesign];

                const updateConditionalDependencies =
                    projectElement.auxState.selectedDesignPublicId !== selectedDesignPublicId;

                commit(
                    AUX_MUTATION,
                    {
                        elementId: element.PublicId,
                        auxState: {
                            incentiveDesigns: projectElement.auxState.incentiveDesigns,
                            selectedDesignPublicId: selectedDesignPublicId,
                            isLoading: false,
                            // If the selected design has changed, put the Incentive Selector into
                            //  "calculating" mode so that a Calculation cannot begin before the
                            //  saveFormData below completes
                            isCalculating: updateConditionalDependencies,
                            userIsAdmin: projectElement.auxState.userIsAdmin
                        }
                    },
                    { root: true }
                );

                await dispatch(SET_PROJECT_DATA, { dataFieldId, value: selectedDesignName });
                await incentiveSelectorController.clearOutputValuesAsync(element, dispatch);

                if (updateConditionalDependencies) {
                    let saveCancelled = false;
                    let saveError = null;
                    // Save the data first
                    try {
                        await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData, null, { root: true });
                    } catch (e) {
                        // If the save did not occur because an admin cancelled it from the Admin page,
                        //  do not throw the error that was returned
                        if (baseController.inAdminMode && !baseController.admninSaveConfirmed) {
                            saveCancelled = true;
                        } else {
                            saveError = e;
                        }
                    } finally {
                        commit(
                            AUX_MUTATION,
                            {
                                elementId: element.PublicId,
                                auxState: {
                                    incentiveDesigns: projectElement.auxState.incentiveDesigns,
                                    selectedDesignPublicId: selectedDesignPublicId,
                                    isLoading: false,
                                    // Turn off "calculating" mode
                                    isCalculating: false,
                                    userIsAdmin: projectElement.auxState.userIsAdmin
                                }
                            },
                            { root: true }
                        );
                    }

                    if (saveCancelled) {
                        return;
                    } else if (saveError) {
                        throw saveError;
                    }

                    // Keep the unconditional dependencies
                    const newDependencies = element.DependencyDefinitions.filter((dep) => !dep.IsConditional).map(
                        (dep) => dep.DataFieldId
                    );

                    // Get the new conditional dependencies
                    const result = await dispatch(
                        PROJECT_FORM_CONTROLLER_TYPES.actions.updateIncentiveSelectorConditionalDependencies,
                        {
                            formElementId: elementId,
                            incentiveDesignId: selectedDesignPublicId
                        },
                        { root: true }
                    );

                    // Add the conditional dependencies to the array, even if they're already included as unconditional
                    //  dependencies; this alerts the downstream code that the data field is both an unconditional and
                    //  conditional dependency
                    const dependencies = result.Data;
                    dependencies.forEach(function (d) {
                        newDependencies.push(d.Item2);
                    });

                    // Commit the unconditional and conditional arrays to the FieldDependencies for the ProjectElement
                    commit("commitProjectElementFieldDependencies", {
                        elementId: elementId,
                        fieldDependencies: newDependencies
                    });
                }
            },
            async [UPDATE_INCENTIVE](
                { getters, rootGetters, commit, dispatch },
                { elementId, selectedDesignPublicId, overrideAmount, overrideReason }
            ) {
                const { promise, resolveHook, rejectHook } = createPromiseAndGetResolveRejectHooks();
                await dispatch(PROJECT_FORM_CONTROLLER_TYPES.actions.registerSavePromise, promise, { root: true });
                const queueOptions = { skipQueue: true };

                const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                const projectElement = getters[PROJECT_ELEM_FROM_ID](elementId);
                commit(
                    AUX_MUTATION,
                    {
                        elementId: element.PublicId,
                        auxState: {
                            incentiveDesigns: projectElement.auxState.incentiveDesigns,
                            selectedDesignPublicId: selectedDesignPublicId,
                            isLoading: projectElement.auxState.isLoading,
                            isCalculating: true,
                            userIsAdmin: projectElement.auxState.userIsAdmin
                        }
                    },
                    { root: true }
                );

                let error = null;

                try {
                    await dispatch(
                        PROJECT_FORM_CONTROLLER_TYPES.actions.saveFormData,
                        { queueOptions },
                        { root: true }
                    );
                    let result = null;

                    if (selectedDesignPublicId === ADMIN_OVERRIDE_DESIGN) {
                        result = await dispatch(
                            PROJECT_FORM_CONTROLLER_TYPES.actions.overrideIncentive,
                            {
                                formElementId: elementId,
                                incentiveDesignId: selectedDesignPublicId,
                                overrideAmount: overrideAmount,
                                overrideReason: overrideReason,
                                queueOptions
                            },
                            { root: true }
                        );
                        const promises = [];
                        for (const dataFieldId in result.Data.OutputValues) {
                            if (result.Data.OutputValues.hasOwnProperty(dataFieldId)) {
                                const value = result.Data.OutputValues[dataFieldId];
                                // An empty string is a valid incentive design metadata value
                                if (value || value === "") {
                                    promises.push(dispatch(SET_PROJECT_DATA, { dataFieldId, value }));
                                }
                            }
                        }
                        resolveHook();
                        await Promise.all(promises);
                    } else {
                        result = await dispatch(
                            PROJECT_FORM_CONTROLLER_TYPES.actions.calcIncentive,
                            {
                                formElementId: elementId,
                                incentiveDesignId: selectedDesignPublicId,
                                queueOptions
                            },
                            { root: true }
                        );
                        const promises = [];
                        for (const dataFieldId in result.Data.OutputValues) {
                            if (result.Data.OutputValues.hasOwnProperty(dataFieldId)) {
                                const value = result.Data.OutputValues[dataFieldId];
                                // An empty string is a valid incentive design metadata value
                                if (value || value === "") {
                                    promises.push(dispatch(SET_PROJECT_DATA, { dataFieldId, value }));
                                }
                            }
                        }
                        resolveHook();
                        await Promise.all(promises);
                    }

                    if (result.Data.ErrorMessage) {
                        await incentiveSelectorController.clearOutputValuesAsync(element, dispatch);
                        error = result.Data.ErrorMessage;
                    }
                } catch (ex) {
                    rejectHook(ex);
                    throw ex;
                } finally {
                    commit(
                        AUX_MUTATION,
                        {
                            elementId: element.PublicId,
                            auxState: {
                                incentiveDesigns: projectElement.auxState.incentiveDesigns,
                                selectedDesignPublicId: selectedDesignPublicId,
                                isLoading: projectElement.auxState.isLoading,
                                isCalculating: false,
                                userIsAdmin: projectElement.auxState.userIsAdmin
                            }
                        },
                        { root: true }
                    );
                }

                return error;
            },
            async [SET_PROJECT_DATA](
                { state, rootState, getters, rootGetters, commit, dispatch },
                { dataFieldId, value, index }
            ) {
                //check that project is not locked
                if (projectLockStore.isLocked) {
                    return;
                }
                //check that project is not in a readonly mode
                if (
                    state.ProjectFormMode === PROJECT_FORM_MODE.View ||
                    state.ProjectFormMode === PROJECT_FORM_MODE.Print
                ) {
                    return;
                }
                //check to make sure datafield actually exists
                if (!rootState[PROJECT_NAMESPACE].DataFields[dataFieldId]) {
                    return;
                }

                // We don't save changes automatically on page turn in prefill mode
                if (
                    state.ProjectFormMode === PROJECT_FORM_MODE.Prefill ||
                    state.ProjectFormMode === PROJECT_FORM_MODE.PrefillAdmin
                ) {
                    $app.setUnsavedChanges(true);
                }
                commit(COMMIT_SAVE_STATE, PROJECT_FORM_SAVE_STATE.HasUnsaved);

                // if there is an error associated with with the field being set, clear it.
                const currentElementId = getters.fieldToElementIndex[dataFieldId];
                const currentProjectElement = getters[PROJECT_ELEM_FROM_ID](currentElementId);
                if (currentProjectElement && currentProjectElement.hasValidationError) {
                    commit("clearValidationErrorForElementId", currentElementId);
                }

                const dfd = rootGetters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](dataFieldId);

                if (dfd.IsMultiInstance) {
                    if (index != null) {
                        commit(
                            PROJECT_TYPES.mutations.commitMultiDataItem,
                            { dataFieldId, value, index },
                            { root: true }
                        );
                    } else {
                        commit(PROJECT_TYPES.mutations.commitProjectMultiData, { dataFieldId, value }, { root: true });
                    }
                    // multi instance data doesnt have dependencies, so there is nothing else to do.
                    return;
                }

                const currentValue = rootGetters[PROJECT_TYPES.getters.dataFieldValueFromId](dataFieldId);
                if (value === null || value === undefined) {
                    value = "";
                }
                if (currentValue === value) {
                    return;
                }

                commit(PROJECT_TYPES.mutations.commitProjectData, { dataFieldId, value }, { root: true });
                // NOTE: only commit datafield value changes for dataFieldId.
                // Any followup actions that affect data field values should be dispatched as proper store actions.
                // For example, it's fine to commit changes to IsVisible for several elements, but the followup
                // clearing and filling of default values when shown should be done via a store action dispatch.

                const deps = getters.fieldToElementDependencyIndex[dataFieldId];
                if (deps) {
                    const promises = [];
                    for (const elementId in deps) {
                        if (deps.hasOwnProperty(elementId)) {
                            const projectElement = getters[PROJECT_ELEM_FROM_ID](elementId);
                            const element = rootGetters[FORM_TYPES.getters.elementFromId](elementId);
                            promises.push(
                                // onDependencyUpdate is expected to throw if we need to cancel the operation.
                                onDependencyUpdate({
                                    $app,
                                    baseController,
                                    element,
                                    projectElement,
                                    dataFieldId,
                                    rootGetters,
                                    dispatch,
                                    commit,
                                    state
                                })
                            );
                        }
                    }
                    try {
                        await Promise.all(promises);
                    } catch (e) {
                        if (IS_DEBUG_BUILD) {
                            console.log(e);
                        }
                        commit(
                            PROJECT_TYPES.mutations.commitProjectData,
                            { dataFieldId, value: currentValue },
                            { root: true }
                        );
                        return;
                    }
                }

                // order:
                // 1. store current value in temp var
                // 2. commit new value
                // 3. form validation?
                // 2. dependency checks e.g. pv system zip change, or incentive design changes
                // 3. any other cancellable actions that can prevent the save
                // 4. restore original value if needed and exit
            },
            async [CONFIRM_DISCARD_UNSAVED_DATA]({ state }) {
                if (state.saveState !== PROJECT_FORM_SAVE_STATE.HasUnsaved) {
                    return true;
                }

                const cancelResult = "CANCEL";
                const discardAndContinueResult = "OK";

                const dialogResult = await $app.showDialog({
                    title: getI18nStr(KEYS.confirmDiscardUnsavedHeader),
                    message: getI18nStr(KEYS.confirmDiscardUnsavedMessage),
                    buttons: [
                        {
                            text: getI18nStr(KEYS.confirmDiscardUnsavedCancelBtnLabel),
                            result: cancelResult
                        },
                        {
                            text: getI18nStr(KEYS.confirmDiscardUnsavedConfirmBtnLabel),
                            primary: true,
                            result: discardAndContinueResult
                        }
                    ]
                });

                if (dialogResult === cancelResult) {
                    return Promise.reject("User cancelled discard unsaved changes");
                } else {
                    $app.setUnsavedChanges(false);
                }
            }
        }
    };
}
function commitSignatureAndRequestStatus(
    { getters, rootGetters, state, commit },
    { signatureRequested, signatureRequestStatus, allSignatures }
) {
    const eSigElementBags = getters[VISIBLE_E_SIGNATURE_ELEMENT_BAGS];
    eSigElementBags.forEach((eSigBag) => {
        const signatureStatus = { ...eSigBag.projectElement.AuxiliaryModel };
        if (allSignatures || !signatureStatus.HasCompletedESignature) {
            if (signatureRequested) {
                signatureStatus.SignatureRequested = true;
            } else {
                signatureStatus.SignatureRequested = false;
                signatureStatus.IsReady = false;
                signatureStatus.HasCompletedESignature = false;
            }

            commit("commitSignatureStatus", { elementId: eSigBag.element.PublicId, signatureStatus });
        }
    });

    const orderedElements = rootGetters[FORM_TYPES.getters.orderedFormElements];
    orderedElements.forEach((element) => {
        const isVisible = state.ProjectElements[element.PublicId].IsVisible;
        if (isVisible && element.ClassName === "SignatureRequestElement") {
            commit("commitSignatureRequestStatus", {
                elementId: element.PublicId,
                signatureRequestStatus
            });
        }
    });
}
function commitUpdateClassicESignatureDocumentStatuses({ commit }, { classicESignatureDocumentStatus }) {
    commit("commitClassicESignatureDocumentStatuses", { classicESignatureDocumentStatus });
}

/**
 * Get a Promise that represents no action in particular, along with access
 * to hooks to resolve or reject it. Can be used to control the execution of a
 * chain of async actions. Because the Promise doesn't do anything in particular,
 * it will remain pending forever until one of the hooks is called.
 * @returns A promise along with hooks to resolve or reject it
 */
function createPromiseAndGetResolveRejectHooks() {
    let _resolve;
    let _reject;
    const p = new Promise((resolve, reject) => {
        _resolve = resolve;
        _reject = reject;
    });
    return {
        promise: p,
        resolveHook: _resolve,
        rejectHook: _reject
    };
}
